export default __webpack_public_path__ + "static/media/notification.a2593df0.mp3";